import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spin, Tabs, } from 'antd';
import { txt } from 'libs/i18n';
import { CreditCardOutlined } from '@ant-design/icons';
import { useState, useEffect } from 'react';
import { useSession } from 'components/Authenticated';
import { PRODUCT_BEEY, PRODUCT_VIP_BEEY, PRODUCT_ND6, PRODUCT_VIP_ND6, } from 'api/model/subscription-plan';
import styles from './style.module.less';
import PlanCard from './PlanCard';
import IntervalSwitch from './IntervalSwitch';
const PlansOverview = ({ currency, subscriptions, onCreatePortalSession, stripePlans, onCreateOrder, }) => {
    const { session } = useSession();
    const [interval, setInterval] = useState('year');
    const [quantityByPlan, setQuantityByPlan] = useState({});
    useEffect(() => {
        if (stripePlans !== 'loading') {
            stripePlans.forEach((plan) => {
                if (quantityByPlan[plan.planKey] === undefined) {
                    setQuantityByPlan((prev) => (Object.assign(Object.assign({}, prev), { [plan.planKey]: 1 })));
                }
            });
        }
    }, [stripePlans]);
    const handleSetQuantity = (planKey, value) => {
        setQuantityByPlan((prev) => (Object.assign(Object.assign({}, prev), { [planKey]: value })));
    };
    const createPlansToDisplay = (plans) => (plans !== 'loading'
        ? plans.filter((plan) => plan.interval === interval || plan.interval === null)
        : []);
    const beeyPlans = stripePlans !== 'loading'
        ? stripePlans.filter((plan) => plan.planKey.startsWith(PRODUCT_BEEY) || plan.planKey.startsWith(PRODUCT_VIP_BEEY))
        : 'loading';
    const nd6Plans = stripePlans !== 'loading'
        ? stripePlans.filter((plan) => plan.planKey.startsWith(PRODUCT_ND6) || plan.planKey.startsWith(PRODUCT_VIP_ND6))
        : 'loading';
    const createTabContent = (plans, showEnterprise, showQuantity = false, infoText) => {
        if (stripePlans === 'loading' || stripePlans.length <= 1) {
            return _jsx(Spin, {});
        }
        const plansToDisplay = createPlansToDisplay(plans);
        return (_jsxs("div", { className: styles.plans, children: [_jsx(IntervalSwitch, { value: interval, onChange: setInterval, infoText: infoText }), _jsxs("div", { className: styles.cards, children: [plansToDisplay.map((plan) => {
                            var _a, _b, _c, _d, _e, _f;
                            return (_jsx(PlanCard, { planKey: plan.planKey, planName: plan.displayName, planPrice: (_b = (_a = plan.currenciesPrices[currency.toLowerCase()]) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : 0, planPricePerMinute: (_d = (_c = plan.currenciesPrices[currency.toLowerCase()]) === null || _c === void 0 ? void 0 : _c.pricePerMinute) !== null && _d !== void 0 ? _d : 0, planQuantity: plan.planMetadata.orderMinQuantity, onCreateOrder: onCreateOrder, subscriptions: subscriptions, planInterval: plan.interval, planPriceId: plan.description, currency: currency, onCreatePortalSession: onCreatePortalSession, isPrivate: plan.isPrivate, isRecurring: plan.isRecurring, quantity: showQuantity ? Math.max(1, (_e = quantityByPlan[plan.planKey]) !== null && _e !== void 0 ? _e : 1) : 1, setQuantity: showQuantity
                                    ? (value) => handleSetQuantity(plan.planKey, value)
                                    : undefined, unitLabel: (_f = plan.intervalDisplayText) !== null && _f !== void 0 ? _f : '' }, plan.planKey));
                        }), showEnterprise && (_jsx(PlanCard, { planPriceId: "enterprise", planKey: "enterprise", planName: "Enterprise", planPrice: 0, planPricePerMinute: 0, planQuantity: 0, planInterval: null, onCreateOrder: onCreateOrder, subscriptions: subscriptions, currency: currency, onCreatePortalSession: onCreatePortalSession, isPrivate: false, isRecurring: false, quantity: 1, setQuantity: undefined, unitLabel: "" }))] })] }));
    };
    const items = [
        {
            key: '1',
            label: 'Beey',
            children: createTabContent(beeyPlans, true, false, txt('twoFreeMonths')),
        },
        {
            key: '2',
            label: 'Newton Dictate 6',
            children: createTabContent(nd6Plans, false, true, null),
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsxs("h1", { className: styles.title, children: [_jsx(CreditCardOutlined, {}), ' ', txt('plansAndPricing')] }), session.login.hasClaim('admin:superadmin') ? (_jsx(Tabs, { items: items })) : (createTabContent(beeyPlans, true, false, txt('twoFreeMonths')))] }));
};
export default PlansOverview;
